import(/* webpackMode: "eager" */ "/codebuild/output/src2466465509/src/apps/pickuji/src/app/error.tsx");
